import React, { useEffect, useState } from "react";
import { formadate } from "../../_App/Helpers/helpers";
import ClientType from "../../_App/Types/Entites/ClientType";
import FicheClient from "./FicheClient";
import Swal from "sweetalert2";
import { blockClientApi } from "../../_App/Redux/Slices/client/clientSlice";
import { useAppDispatch } from "../../_App/Redux/hooks";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";

export default function ClientTable({
  Listclient,
  updateFunction,
  desactiveFunction,
  activeFunction,
  t,
  currentPage,
  totalPages,
  setPage,
}: any) {
  const [list_client, setlist_client] = useState<ClientType[]>(Listclient);
  const dispatch = useAppDispatch();

  // Modal state - only ONE modal for the entire table
  const [selectedClient, setSelectedClient] = useState<ClientType | null>(null);
  const [showFicheModal, setShowFicheModal] = useState(false);

  useEffect(() => {
    setlist_client(Listclient);
  }, [Listclient]);

  const verifcationMsg = (msg: string) => {
    return Swal.fire({
      title: t("vous-êtes sûr?"),
      text: msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Confirmer!"),
      cancelButtonText: t("Cancel!"),
    }).then((result) => result.isConfirmed);
  };

  const blockFunction = async (id: any) => {
    const isConfirmed = await verifcationMsg(t("Bloquer ce client?"));
    if (isConfirmed) {
      const result = await dispatch(blockClientApi(id));
      if (result.payload) {
        ToastSuccess(t("Client bloqué avec succès"));
      } else {
        ToastWarning(t("Erreur lors du blocage"));
      }
    }
  };

  const handleViewFiche = (client: ClientType) => {
    setSelectedClient(client);
    setShowFicheModal(true);
  };

  // Generate page numbers to display (max 5 pages)
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  return (
    <div className="card-box-app row m-0 p-3 mt-3">
      <div className="table-responsive col-12">
        <table className="table table-striped table-hover text-center align-middle">
          <thead>
            <tr>
              <th>{t("Code")}</th>
              <th>{t("Nom complet")}</th>
              <th>{t("Téléphone")}</th>
              <th>{t("Email")}</th>
              <th>{t("Catégorie")}</th>
              <th>{t("Fiche")}</th>
              <th>{t("Action")}</th>
            </tr>
          </thead>
          <tbody>
            {list_client?.map((item: ClientType, index) => (
              <tr key={index}>
                <td>{item.barCode}</td>
                <td>{item.nom + " " + (item.prenom || "")}</td>
                <td>{item.mobile}</td>
                <td>{item.email}</td>
                <td>{item.niveauFidelite?.libelle || "-"}</td>
                <td>
                  {/* Button to open modal - NOT rendering the modal itself */}
                  <button
                    className="btn btn-sm btn-info"
                    onClick={() => handleViewFiche(item)}
                    style={{
                      backgroundColor: "#06958d",
                      borderColor: "#06958d",
                    }}
                  >
                    <i className="fas fa-eye me-1"></i>
                    {t("Voir fiche")}
                  </button>
                </td>
                <td>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "1.2em",
                      marginRight: "10px",
                    }}
                    onClick={() => updateFunction(item)}
                    title={t("Modifier")}
                  >
                    <i className="fas fa-edit" style={{ color: "#06958d" }}></i>
                  </span>

                  {item.actif ? (
                    <>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "1.2em",
                          marginRight: "10px",
                          color: "#dc3545",
                        }}
                        onClick={() => desactiveFunction(item._id)}
                        title={t("Désactiver")}
                      >
                        <i className="fas fa-power-off"></i>
                      </span>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "1.2em",
                          marginRight: "10px",
                        }}
                        onClick={() => blockFunction(item._id)}
                        title={t("Bloquer")}
                      >
                        <i className="fas fa-ban text-danger"></i>
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "1.2em",
                          marginRight: "10px",
                          color: "#28a745",
                        }}
                        onClick={() => activeFunction(item._id)}
                        title={t("Activer")}
                      >
                        <i className="fas fa-power-off"></i>
                      </span>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "1.2em",
                          marginRight: "10px",
                        }}
                        onClick={() => blockFunction(item._id)}
                        title={t("Bloquer")}
                      >
                        <i className="fas fa-ban text-danger"></i>
                      </span>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Improved Pagination Controls */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center mt-4 pt-2 border-top">
          <div className="text-muted small">
            <i className="fas fa-list-alt me-1"></i>
            {t("Page")} {currentPage} {t("sur")} {totalPages}
            <span className="ms-2">
              | {t("Total")}: {list_client.length} {t("clients")}
            </span>
          </div>
          <nav>
            <ul className="pagination pagination-sm mb-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  type="button"
                  onClick={() =>
                    setPage((prev: number) => Math.max(prev - 1, 1))
                  }
                  aria-label="Previous"
                >
                  <span aria-hidden="true">&laquo;</span>
                  <span className="ms-1 d-none d-sm-inline">
                    {t("Précédent")}
                  </span>
                </button>
              </li>

              {getPageNumbers()[0] > 1 && (
                <>
                  <li className="page-item">
                    <button
                      className="page-link"
                      type="button"
                      onClick={() => setPage(1)}
                    >
                      1
                    </button>
                  </li>
                  {getPageNumbers()[0] > 2 && (
                    <li className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  )}
                </>
              )}

              {getPageNumbers().map((pageNumber) => (
                <li
                  key={pageNumber}
                  className={`page-item ${
                    currentPage === pageNumber ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    type="button"
                    onClick={() => setPage(pageNumber)}
                    style={
                      currentPage === pageNumber
                        ? {
                            backgroundColor: "#06958d",
                            borderColor: "#06958d",
                            color: "#fff",
                          }
                        : {}
                    }
                  >
                    {pageNumber}
                  </button>
                </li>
              ))}

              {getPageNumbers()[getPageNumbers().length - 1] < totalPages && (
                <>
                  {getPageNumbers()[getPageNumbers().length - 1] <
                    totalPages - 1 && (
                    <li className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  )}
                  <li className="page-item">
                    <button
                      className="page-link"
                      type="button"
                      onClick={() => setPage(totalPages)}
                    >
                      {totalPages}
                    </button>
                  </li>
                </>
              )}

              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  type="button"
                  onClick={() =>
                    setPage((prev: number) => Math.min(prev + 1, totalPages))
                  }
                  aria-label="Next"
                >
                  <span className="d-none d-sm-inline">{t("Suivant")}</span>
                  <span aria-hidden="true" className="ms-1">
                    &raquo;
                  </span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}

      {/* SINGLE MODAL INSTANCE - Rendered once at the bottom */}
      {selectedClient && (
        <FicheClient
          t={t}
          client={selectedClient}
          ShowModalClient={showFicheModal}
          setShowModalClient={setShowFicheModal}
        />
      )}
    </div>
  );
}
